export const FETCH_VIDEO_TRANSCRIPT_SUCCESS = "app/youtube/FETCH_VIDEO_TRANSCRIPT_SUCCESS";
export const FETCH_VIDEO_TRANSCRIPT_FAIL = "app/youtube/FETCH_VIDEO_TRANSCRIPT_FAIL";